import { Inject, Injectable, Optional } from "@angular/core";
import { DigitsInfo } from "../models/digits-info";
import { TCM_FORM_CONFIG, TCMFormConfig } from "../tcm-form-config";

@Injectable()
export class ConfigurationManager {
  private static readonly _defaultPercentDigitInfo: DigitsInfo = {
    minIntegerDigits: 1,
    minFractionDigits: 2,
    maxFractionDigits: 2,
  };

  constructor(
    @Optional() @Inject(TCM_FORM_CONFIG) private config: TCMFormConfig
  ) {}

  getPercentDigitInfo(): DigitsInfo {
    if (this.config && this.config.digitInfoPercent) {
      return {
        minIntegerDigits: this.config.digitInfoPercent.minIntegerDigits,
        minFractionDigits: this.config.digitInfoPercent.minFractionDigits,
        maxFractionDigits: this.config.digitInfoPercent.maxFractionDigits,
      };
    }

    return ConfigurationManager._defaultPercentDigitInfo;
  }
}
